import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../ReviewDetail.css";
import config from "../config";
import Gallery from "./Gallery";
import RatingWrapper from "./RatingWrapper";

function Kebabdetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [review, setReview] = useState(null);
  const hasFetched = useRef(false);
  const [liked, setLiked] = useState(() => {
    return localStorage.getItem(`liked_${id}`) === "true";
  });
  const [likeCount, setLikeCount] = useState(0);
  const [isLiking, setIsLiking] = useState(false);

  const handleLike = async () => {
    if (liked || isLiking) return;
    setIsLiking(true);
    setLiked(true);
    setLikeCount((c) => c + 1);
    localStorage.setItem(`liked_${id}`, "true");
    try {
      const res = await fetch(`${config.BaseUrl}/reviews/like/${id}`, {
        method: "PATCH",
      });
      const data = await res.json();
      const serverCount = data.likes ?? data.likeCount;
      if (serverCount != null) setLikeCount(serverCount);
    } catch (err) {
      console.error("Fehler beim Liken:", err);
      setLiked(false);
      setLikeCount((c) => c - 1);
      localStorage.removeItem(`liked_${id}`);
    } finally {
      setIsLiking(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    const fetchReview = async () => {
      try {
        const res = await fetch(`${config.BaseUrl}/reviews/${id}`);
        const data = await res.json();
        setReview(data.review);
        setLikeCount(data.review.likes ?? data.review.likeCount ?? 0);
        if (localStorage.getItem(`viewed_${id}`) !== "true") {
          localStorage.setItem(`viewed_${id}`, "true");
          fetch(`${config.BaseUrl}/reviews/views/${id}`, { method: "PATCH" }).catch(() => {});
        }
      } catch (err) {
        console.error("Fehler beim Laden der Review:", err);
      }
    };
    fetchReview();
  }, [id]);

  const renderDetail = () => {
    if (!review) return <div>Loading Review</div>;

    return (
      <div className="detail-card">
        <button className="back-btn" onClick={() => navigate("/")}>
          ← Zurück
        </button>
        <div className="detail-body">
          <h2 className="detail-title">{review.title}</h2>
          <p className="detail-address">{review.address}</p>
          <p className="detail-rating">⭐ {review.rating} von 5</p>
          <p className="detail-views">
            <i class="fa-regular fa-eye" />  {review.views} Aufrufe
          </p>
          <p className="detail-text">{review.text}</p>
        </div>

        {review.image && <Gallery images={review.images} />}
        <div className="ratingsection">
          <RatingWrapper rating={review.cleanliness} title={"Sauberkeit"} />
          <RatingWrapper rating={review.atmosphere} title={"Atmosphäre"} />
          <RatingWrapper rating={review.taste} title={"Geschmack "} />
          <RatingWrapper rating={review.service} title={"Service"} />
        </div>
      </div>
    );
  };
  return (
    <div className="detail-container">
      {renderDetail()}
      <button
        className={`like-btn${liked ? " liked" : ""}`}
        onClick={handleLike}
        disabled={liked || isLiking}
        aria-label="Gefällt mir"
      >
        <i className={liked ? "fa-solid fa-heart" : "fa-regular fa-heart"} />
        <span>{likeCount}</span>
      </button>
    </div>
  );
}

export default Kebabdetail;
